import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase';

const getInvoicePdf = httpsCallable(functions, 'getInvoicePdf');

/**
 * Calls the Cloud Function to generate an invoice PDF and triggers a browser download.
 * @param {string} invoiceId  Firestore document ID
 * @param {string} invoiceNumber  Used as the downloaded filename
 * @returns {Promise<void>}
 */
export async function downloadInvoicePdf(invoiceId, invoiceNumber) {
  const result = await getInvoicePdf({ invoiceId });
  const { pdfBase64, filename } = result.data;

  // Decode base64 to binary and create a Blob
  const binary = atob(pdfBase64);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i);
  }
  const blob = new Blob([bytes], { type: 'application/pdf' });

  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename || `${invoiceNumber}.pdf`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
